import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import showAlert from '../../../utils/alert';

const createPpeComponentMasterQuery = (data) => {
  return axios.post(apiurl?.createPpeComponentMaster, data);
};

const createPpeComponentMaster = () => {
  const queryClient = useQueryClient();
  return useMutation(createPpeComponentMasterQuery, {
    onSuccess: () => {
      showAlert('PPE Component Added Successfully!', 'success');
      queryClient.invalidateQueries('getAllPpeComponentMaster');
    },
    onError: (error) => {
      showAlert(error?.response?.data, 'error');
    }
  });
};

export default createPpeComponentMaster;
